
module.exports = {
    publicPath: "/",
    devServer: {
        open: true,   //自动启动浏览器
        https: false,      // 如果开启就会以https开头。
        hotOnly: false,      //安装模块更好的兼容，不需要配置。
        proxy: {
            '/api': {
                target: 'http://localhost:5000', // 目标接口的域名
                // secure: true,  // https 的时候 使用该参数
                changeOrigin: true,  // 是否跨域
                pathRewrite: { '^/api': '' }
            }
        }
    },

    configureWebpack: {
        externals: {
            AMap: "AMap",
        },
    },

}

